import { createStyles, rem } from '@mantine/core'
import { DetectPageReturnType } from 'hooks/useDetectSCpage'

type StylesParams = {
  unsetRatio?: boolean
  detectPage: DetectPageReturnType
}

export default createStyles(
  (theme, { unsetRatio, detectPage: { isSimilac } }: StylesParams) => {
    const themeColors = theme.colors as any
    return {
      root: {},
      container: {},
      wrapper: {
        gap: rem(32),
        padding: `${rem(24)} 0`,
        [theme.fn.largerThan('sm')]: {
          gap: rem(64),
          padding: rem(80),
        },
      },
      heading: {},
      description: { color: theme.colors.gray[8] },
      bannerImg: {
        [theme.fn.largerThan('sm')]: {
          maxWidth: rem(744),
        },
      },
      optionList: {
        display: 'flex',
        [theme.fn.smallerThan('sm')]: {
          flexDirection: 'column',
          width: '100%',
          gap: rem(12),
        },
        [theme.fn.largerThan('sm')]: {
          justifyContent: 'center',
          gap: rem(24),
          '.item': {
            width: rem(264),
          },
        },
      },
      radioOptionRoot: {
        ...(isSimilac && {
          backgroundColor: '#fff',
        }),
        ...(!unsetRatio && {
          borderRadius: rem(16),
          border: '2px solid transparent',
          boxShadow: `0px 0px 1px 0px rgba(0, 0, 0, 0.04), 0px 2px 8px 0px rgba(0, 0, 0, 0.04), 0px 16px 24px 0px rgba(0, 0, 0, 0.06)`,
          transition: 'all .1s ease',
          '&[data-checked="true"]': {
            borderColor: theme.fn.primaryColor(),
            backgroundColor: themeColors[theme.primaryColor][0],
          },
        }),
      },
      radioOptionLabel: {
        padding: 0,
        cursor: 'pointer',
      },
      radioOptionLabelWrapper: { width: '100%' },
      radioOptionInner: { display: 'none' },
      optionRoot: {},
      optionWrapper: {},
      optionThumbnail: {},
      optionHeading: {},
    }
  },
)
